import $ from "jquery";
import compile from "@bd-utils/handlerbars-helper";
import BD_Component from "@bd-core/bd-component";
import fb from "@bd-core/firebase";
import bdjs from "@bd-core/bdjs";
import CONFIG from "@bd-core/config";
import { getRoomAnswerById } from "@bd-stores/game-data";
import { getCurrentPageId } from "@bd-stores/user-progress";
import CompletionPopup from "@bd-utils/completion-popup";
import {
    getPlayers,
    getRoomStatus,
    getTeamAnswers,
    getFinalTeamAnswers,
} from "@bd-stores/game-progress";
import {
    maybeUpdateRoomStatus,
    updateRoomAnswer,
    saveFinalRoomAnswers,
} from "@bd-core/firebase-actions";
import gsap from "gsap";
import Draggable from "gsap/Draggable";

export class RoomSwitchPuzzle extends BD_Component {
    constructor() {
        super();

        this.id = "switch_puzzle";
        this.templateID = "switch_puzzle-template";

        this.elms = {
            puzzleContent: "#switchPuzzle",
            puzzleOverlay: ".js-puzzle-popup",
            openPuzzle: ".js-switchPuzzle-open",
            closePuzzle: ".js-switchPuzzle-close",
            puzzleItem: ".js-puzzle-item",
            panelItem: ".js-panel-item",
            actions: ".js-actions",
            confirmation: "#initialSubmit",
            closeNotMatch: ".js-mismatch-close",
            answerMismatch: ".js-answer-mismatch",
            answerWaiting: ".js-answer-waiting",
            answerWrong: ".js-answer-wrong",
            background: ".js-screen-img",
            backgroundImage: ".screen__navigate",
            lightAnswer: ".js-sync-answer",
            resultFeedback: ".js-feedback",
            hintBtn: ".js-hint-btn",
        };

        this._events = this.getEvents();

        this.fbEvents = [];

        this.completionPopup = new CompletionPopup();

        this.startX = 0;
        this.startY = 0;
        this.zoom = 100;
        this.hotspotSize = 21.5;
        this.isDown = false;
    }

    /**
     * @returns {Array<BD_ComponentEvent>}
     */
    getEvents() {
        const elms = this.elms;
        return [
            {
                event: "click",
                selector: elms.puzzleItem,
                handler: this.chooseItem,
            },
            {
                event: "click",
                selector: elms.confirmation,
                handler: this.submit,
            },
            {
                event: "click",
                selector: `${elms.openPuzzle}, ${elms.closePuzzle}`,
                handler: this.onTogglePuzzle,
            },
            {
                event: "click",
                selector: elms.closeNotMatch,
                handler: this.onTogglenotMatch,
            },
            {
                event: "wheel",
                selector: elms.background,
                handler: this.onBackgroundScroll,
            },
        ];
    }

    beforeInit() {
        this.render();
        this.setGameState();
        const roomStatus = getRoomStatus(this.roomId);
        if (roomStatus !== "is-status-completed") this.listenScannedUsers();
    }

    getModifiedData() {
        const modified = { ...this._data };
        const players = getPlayers();
        const onlinePlayers = players.filter((player) => player.isOnline);

        let _challenge = this._data.challenges;
        const defaultNormalImage = `${CONFIG.themeURL}/assets/images/filestack.png`;
        const defaultHoverImage = `${CONFIG.themeURL}/assets/images/filestack-hover.png`;
        const defaultImageBg = `${CONFIG.themeURL}/assets/images/bg-switch-puzzle-new.png`;

        const _image_bg = this._data.image_bg
            ? this._data.image_bg
            : defaultImageBg;

        _challenge = {
            normal_image: _challenge.normal_image
                ? _challenge.normal_image
                : defaultNormalImage,
            hover_image: _challenge.hover_image
                ? _challenge.hover_image
                : defaultHoverImage,
        };

        const hintHotspots = this._data.hotspots.filter(
            (h) => h["hotspot_type"] === "hint",
        );

        const hotspotCount = hintHotspots.length;
        const defaultValue = "50%";

        const _hints = this._data.hints.map((hint, i) => {
            const font_fam = hint.hint_font_family.split("|");
            const font_name = font_fam[0];
            const font_category = font_fam[1];

            return {
                ...hint,
                font_family: `"${font_name}", ${font_category}`,
                has_image: hint.image,
                position_top:
                    hotspotCount > 0 && hintHotspots[i]
                        ? hintHotspots[i].position_top
                        : defaultValue,
                position_left:
                    hotspotCount > 0 && hintHotspots[i]
                        ? hintHotspots[i].position_left
                        : defaultValue,
            };
        });

        const _hotspots = this._data.hotspots
            .filter((h) => h["hotspot_type"] === "puzzle")
            .shift();

        const modifiedData = {
            ...modified,
            hints: _hints,
            hotspots: _hotspots,
            challenges: _challenge,
            image_bg: _image_bg,
            players: onlinePlayers,
        };

        return modifiedData;
    }

    render() {
        const modifiedData = this.getModifiedData();
        const isForcedOpenChallenge = modifiedData["force_open_challenge"];

        const htmlTemplate = $("#" + this.templateID).html();
        const html = compile(htmlTemplate, modifiedData);
        $(".app").html(html);

        if (isForcedOpenChallenge) {
            this.onForceOppenChallenge();
        }
    }

    onForceOppenChallenge() {
        const elms = this.elms;
        const $puzzleOverlay = $(elms.puzzleOverlay);
        const hasOpen = $puzzleOverlay.hasClass("is-open");
        const isOpened = !hasOpen;
        const blur = $(".app-blur");

        blur.toggleClass("is-blurred", isOpened);

        $puzzleOverlay.toggleClass("is-open", isOpened);
    }

    setGameState() {
        const elms = this.elms;
        const roomID = this.roomId;
        const thisRoomStatus = getRoomStatus(roomID);
        const currentPlayerId = CONFIG.user.id;
        const correctAnswer = getRoomAnswerById(roomID);

        const possibleStatuses = [
            "is-status-open",
            "is-status-started",
            "is-status-completed",
        ];

        gsap.registerPlugin(Draggable);
        let companions;

        Draggable.create(".js-draggable", {
            bounds: $(".screen__container"),
            dragResistance: 0.5,
            edgeResistance: 1,
            type: "x,y",
            zIndexBoost: false,
            onPress: function () {
                const screens = document.querySelectorAll(".js-draggable");
                let i = screens.length;
                companions = [];
                RoomSwitchPuzzle.prototype.startX = this.x;
                RoomSwitchPuzzle.prototype.startY = this.y;
                while (--i > -1) {
                    if (companions[i] !== this.target) {
                        companions.push({
                            element: screens[i],
                            x: gsap.getProperty(screens[i], "x"),
                            y: gsap.getProperty(screens[i], "y"),
                        });
                    }
                }
                gsap.killTweensOf(".js-draggable");
            },
            onDrag: function () {
                let i = companions.length,
                    deltaX = this.x - RoomSwitchPuzzle.prototype.startX,
                    deltaY = this.y - RoomSwitchPuzzle.prototype.startY,
                    companion;
                while (--i > -1) {
                    companion = companions[i];
                    gsap.set(companion.element, {
                        x: companion.x + deltaX,
                        y: companion.y + deltaY,
                    });
                }
            },
        });

        if (thisRoomStatus) {
            const $status = $(".js-room-status");
            $status.removeClass(possibleStatuses);
            $status.addClass(thisRoomStatus);
        }

        const setSelectedItem = (answers, isFinal = 0) => {
            const playerAnswers = isFinal ? answers : answers.answers;
            const isCorrect = isFinal ? true : answers.isCorrect;
            const answerState = isCorrect ? "is-correct" : "is-incorrect";

            $.each(playerAnswers, function (index, panelId) {
                const $selectedItem = $(
                    elms.puzzleItem + `[data-id="${panelId}"]`,
                );

                $selectedItem.addClass("selected");
                $selectedItem
                    .find(elms.panelItem)
                    .toggleClass("is-incorrect", !isCorrect);
            });

            $(elms.resultFeedback).addClass(answerState);
            $(elms.actions).toggleClass("active", !isCorrect);
        };

        if (thisRoomStatus == "is-status-completed") {
            const finalAnswer = getFinalTeamAnswers(roomID);
            if (finalAnswer) setSelectedItem(finalAnswer, 1);

            $(".boolean").addClass("is-completed");
            $(".app__page").addClass("is-room-completed");
            $(elms.lightAnswer).addClass("is-correct");

            /* Show completion popup */ 
            this.completionPopup.show(
                roomID,
                correctAnswer == finalAnswer,
                finalAnswer,
            );
        } else {
            const roomAnswers = getTeamAnswers(roomID);

            if (!roomAnswers) return;

            const myAnswer = currentPlayerId in roomAnswers;

            if (myAnswer) setSelectedItem(roomAnswers[currentPlayerId]);
        }
    }

    // ============================== CUSTOM FUNCTION
    onBackgroundScroll(e) {
        let delta = e.originalEvent.deltaY < 0 ? "up" : "down";
        if (delta === "up" && this.zoom < 120) {
            this.zoom += 2;
            this.hotspotSize += 0.6;
        } else if (delta === "down" && this.zoom > 100) {
            this.zoom -= 2;
            this.hotspotSize -= 0.6;
        }
        $(this.elms.background).css({
            width: `${this.zoom}%`,
            height: `${this.zoom}%`,
            transform: `translate(-50%, -50%)`,
        });
        $(".screen__navigate").css({
            width: `${this.zoom}%`,
            height: `${this.zoom}%`,
            transform: `translate(-50%, -50%)`,
        });
        $(".js-screen-hotspot").css({
            cssText: `width: calc(1rem + ${this.hotspotSize}vw)`,
        });
        this.startX = 0;
        this.startY = 0;
        gsap.set(".js-draggable", { clearProps: "transform" });
    }

    onTogglenotMatch() {
        const $answerMismatch = $(this.elms.answerMismatch);
        const hasOpen = $answerMismatch.hasClass("is-open");
        const isOpened = !hasOpen;

        $answerMismatch.toggleClass("is-open", isOpened);
    }

    chooseItem(e, el) {
        const $el = $(el);
        const elms = this.elms;

        $el.toggleClass("selected");
        $(elms.panelItem).removeClass("is-incorrect");
        $(elms.resultFeedback).removeClass("is-incorrect");
        $(elms.confirmation).prop("disabled", false);

        const selectedItems = $(elms.puzzleItem + ".selected").length;
        const hasSelectedItem = selectedItems > 0;

        $(elms.actions).toggleClass("active", hasSelectedItem);
    }

    submit() {
        const roomID = this.roomId;
        const currentPlayerId = CONFIG.user.id;
        const elms = this.elms;
        const $action = $(elms.actions);
        const $selectedItem = $(elms.puzzleItem + ".selected");
        const roomAnswers = getRoomAnswerById(roomID);
        let roomStatus = "is-status-started";
        let playerAnswers = [];

        if (
            $action.hasClass("is-loading") ||
            $action.hasClass("is-completed")
        ) {
            return false;
        }

        $.each($selectedItem, function (index, id) {
            const panel_id = $(id).attr("data-id");
            playerAnswers.push(panel_id);
        });

        const isCorrect =
            roomAnswers.length === playerAnswers.length &&
            roomAnswers.every(function (answer) {
                return playerAnswers.includes(answer);
            });
        const answerState = isCorrect ? "is-correct" : "is-incorrect";

        $(elms.resultFeedback).addClass(answerState);
        $selectedItem
            .find(elms.panelItem)
            .toggleClass("is-incorrect", !isCorrect);

        $(elms.actions).toggleClass("active", !isCorrect);

        updateRoomAnswer(roomID, {
            [currentPlayerId]: {
                answers: playerAnswers,
                isCorrect: isCorrect,
            },
        });

        maybeUpdateRoomStatus(roomID, roomStatus);
    }

    getCorrectAnswer(answers) {
        const playersAnswers = bdjs.indexedObjectToArray(answers);
        const firstCorrectAnswer = playersAnswers.find(
            (answer) => answer.isCorrect,
        );

        return firstCorrectAnswer?.answers;
    }

    checkIsAllAnswered(answers) {
        const players = getPlayers();
        const totalOnlinePlayer = players.filter((p) => p.isOnline).length;

        if (answers == null) return false;

        const totalPlayerAnswer = Object.keys(answers).length;

        if (totalPlayerAnswer < totalOnlinePlayer) return false;

        return true;
    }

    checkIsAllAnswersCorrect(answers) {
        const playersAnswers = bdjs.indexedObjectToArray(answers);
        const isAllCorrect = playersAnswers.every((answer) => answer.isCorrect);

        return isAllCorrect;
    }

    setSyncAnswerUI(playerAnswers) {
        const elms = this.elms;

        $.each(playerAnswers, function (index, answer) {
            const _index = String(index);
            const answerState = answer.isCorrect
                ? "is-correct"
                : "is-incorrect";

            $(elms.lightAnswer + `[data-user-id="${_index}"]`).addClass(
                answerState,
            );
        });
    }

    /**
     * If current user hasn't answered anything, don't do anything
     * If all user already submit the answer, room completed
     *
     * That is only applied for user that are currently online, offline user
     * would be ignored
     *
     * @param {*} snapshot
     */
    scanUsersListener(snapshot) {
        const playersAnswer = snapshot.val();
        const completed = "is-status-completed";
        const roomID = getCurrentPageId();
        const firstAnswer = this.getCorrectAnswer(playersAnswer);
        const hasAllPlayersAnswered = this.checkIsAllAnswered(playersAnswer);
        const isAllAnswerCorrect = this.checkIsAllAnswersCorrect(playersAnswer);
        const hasBeenCompleted = getRoomStatus(roomID) === completed;

        if (hasBeenCompleted) return;

        if (playersAnswer == null) return;

        this.setSyncAnswerUI(playersAnswer);

        if (!hasAllPlayersAnswered) return;

        if (!isAllAnswerCorrect) return;

        saveFinalRoomAnswers(roomID, firstAnswer);
        maybeUpdateRoomStatus(roomID, completed);
    }

    onTogglePuzzle() {
        const elms = this.elms;
        const $puzzleOverlay = $(elms.puzzleOverlay);
        const hasOpen = $puzzleOverlay.hasClass("is-open");
        const isOpened = !hasOpen;
        const blur = $(".app-blur");

        blur.toggleClass("is-blurred", isOpened);

        $puzzleOverlay.toggleClass("is-open", isOpened);
    }

    /**
     * Callback to check whether the room is ready to finish
     */
    maybeReadyToFinish() {
        if (this.isTheRoomFinish()) return;

        const roomID = this.roomId;
        fb.get(`${fb.roomsPath}/${roomID}/answers`).then(
            this.scanUsersListener.bind(this),
        );
    }

    /**
     * Listener
     * @param {boolean} off turn on/off the event listener
     */
    listenScannedUsers(off = false) {
        const roomID = this.roomId;
        const path = `${fb.roomsPath}/${roomID}/answers`;
        const scanHandler = (data) => this.scanUsersListener(data);
        const finishHandler = () => this.maybeReadyToFinish();

        if (off) {
            this.fbEvents.forEach((fn) => fn.call());
            this.fbEvents = [];
        } else {
            const ansListener = fb.onValue(path, scanHandler);
            const plyListerner = fb.onValue(fb.playersPath, finishHandler);

            this.fbEvents.push(ansListener);
            this.fbEvents.push(plyListerner);
        }
    }

    isTheRoomFinish() {
        return getRoomStatus(this.roomId) == "is-status-completed";
    }

    beforeDestroy() {
        // if(this._data.must_in_room) this.cancel();
        this.listenScannedUsers(true);
    }
}
